import { instance } from "api/apiBase";
import { FeedConnectionStatus, FeedConnectPayload } from "api/syndicationFeed";

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/realtor_com";

export const realtorComApi = {
  getStatus: async (): Promise<FeedConnectionStatus> => {
    const { data } =
      await instance.get<FeedConnectionStatus>(BASE_ENDPOINT_URL);
    return data;
  },

  connect: async (
    payload: FeedConnectPayload
  ): Promise<FeedConnectionStatus> => {
    const { data } = await instance.post<FeedConnectionStatus>(
      BASE_ENDPOINT_URL,
      payload
    );
    return data;
  },

  disconnect: async (): Promise<FeedConnectionStatus> => {
    const { data } =
      await instance.delete<FeedConnectionStatus>(BASE_ENDPOINT_URL);
    return data;
  }
};
